import { getEntityMovementAnimation, } from './entityMovementAnimation';
export const LOCAL_PLAYER_RENDERER_ID = 'player_entity';
export const LOCAL_PLAYER_CACHE_KEY = 'player_entity';
export function sanitizeHorizontalVelocity(velocity) {
    const x = velocity?.x;
    const z = velocity?.z;
    return {
        x: Number.isFinite(x) ? x : 0,
        z: Number.isFinite(z) ? z : 0,
    };
}
export function isLocalPlayerMounted(entity, mountedVehicle) {
    return Boolean(entity.vehicle ?? mountedVehicle);
}
export function getIsCrouched(entity, isLocalPlayer, isLocalPlayerSneaking) {
    return isLocalPlayer ? isLocalPlayerSneaking : Boolean(entity.crouching);
}
export function shouldTrackPlayerEntity(entity) {
    return Boolean(entity.username) && entity.type === 'player';
}
export function shouldProcessRemoteTrackingEntry(params) {
    const { tracking, entity, localPlayerEntity } = params;
    return Boolean(tracking && entity && entity !== localPlayerEntity);
}
export function applyEntityMovementAnimation(params) {
    const { entity, horizontalVelocity, rendererEntityId, mountedVehicle, force = false, isLocalPlayer, isLocalPlayerSneaking, playerPerAnimation, playEntityAnimation, rendererAvailable, } = params;
    const sanitizedVelocity = sanitizeHorizontalVelocity(horizontalVelocity);
    const animation = getEntityMovementAnimation({
        isMounted: isLocalPlayer
            ? isLocalPlayerMounted(entity, mountedVehicle)
            : Boolean(entity.vehicle ?? mountedVehicle),
        isCrouched: getIsCrouched(entity, isLocalPlayer, isLocalPlayerSneaking),
        horizontalVelocity: sanitizedVelocity,
    });
    const cacheKey = String(rendererEntityId);
    if (!force && playerPerAnimation[cacheKey] === animation)
        return false;
    if (!rendererAvailable)
        return false;
    void playEntityAnimation(rendererEntityId, animation);
    playerPerAnimation[cacheKey] = animation;
    return true;
}
export function processMovementAnimations(params) {
    const { localPlayerEntity, localPlayerVehicle, isLocalPlayerSneaking, trackingData, getEntityById, playerPerAnimation, playEntityAnimation, rendererAvailable, } = params;
    if (localPlayerEntity) {
        applyEntityMovementAnimation({
            entity: localPlayerEntity,
            horizontalVelocity: localPlayerEntity.velocity,
            rendererEntityId: LOCAL_PLAYER_RENDERER_ID,
            mountedVehicle: localPlayerVehicle,
            isLocalPlayer: true,
            isLocalPlayerSneaking,
            playerPerAnimation,
            playEntityAnimation,
            rendererAvailable,
        });
    }
    for (const [id, trackerData] of Object.entries(trackingData)) {
        const entity = getEntityById(id);
        if (!shouldProcessRemoteTrackingEntry({
            tracking: trackerData.tracking,
            entity,
            localPlayerEntity,
        }) || !entity)
            continue;
        applyEntityMovementAnimation({
            entity,
            horizontalVelocity: trackerData.info.avgVel,
            rendererEntityId: entity.id,
            mountedVehicle: entity.vehicle,
            isLocalPlayer: false,
            isLocalPlayerSneaking: false,
            playerPerAnimation,
            playEntityAnimation,
            rendererAvailable,
        });
    }
}
export function clearLocalPlayerAnimationCache(playerPerAnimation) {
    delete playerPerAnimation[LOCAL_PLAYER_CACHE_KEY];
}
